import { createStore } from 'vuex'

export default createStore({
  state: {
    isLogin: false,
    username: '',
    token: ''
  },
  getters: {
    isLogin: state => state.isLogin,
    token: state => state.token,
    username: state => state.username
  },
  mutations: {
    updateLogin(state, payload) {
      state.isLogin = payload;
    },
    updateToken(state, payload) {
      state.token = payload;
    },
    updateUsername(state, payload) {
      state.username = payload;
    }
  },
  actions: {
  },
  modules: {
  }
})
